'use strict';

var SearchView = require('../../common/views/search-view');

module.exports = function () {

    var searchView = new SearchView();

};
